/* @flow */

import * as React from 'react';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Tag.style';
import { useId } from 'react-aria';
import classNames from 'classnames';

type Props = {
  id: string,
  name: string,
  value: string,
  checked?: boolean,
  children: React.Node,
  isInactive?: boolean,
  isChecked?: boolean,
  onChange?: (Event) => void,
  onClick?: (Event) => void,
};

const useStyles = createUseThemeStyles(styles);

const TagRadio = ({
  children,
  isInactive = false,
  id,
  name,
  value,
  checked,
  onChange,
  onClick,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */
  const autoId = useId();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({
    isInactive,
    isChecked: checked,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <span className={classNames(classes.root, classes.rootWithRadio)}>
      <input
        id={id || autoId}
        name={name}
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
        onClick={onClick}
      />
      <label
        htmlFor={id || autoId}
        className={classNames(classes.label, 'ignore')}
      >
        {children}
      </label>
    </span>
  );
};

export default React.memo<Props>(TagRadio);
